import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c52852d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "medical-report-main-container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-back-button" }, null, -1))
const _hoisted_4 = { class: "header-title" }
const _hoisted_5 = { class: "header-close-button" }
const _hoisted_6 = { class: "report-details-title" }
const _hoisted_7 = { class: "report-body-container" }
const _hoisted_8 = { class: "report-body-header" }
const _hoisted_9 = { class: "report-body-header_observation" }
const _hoisted_10 = { class: "report-body-header_observation-btn" }
const _hoisted_11 = { class: "report-body-header_objective" }
const _hoisted_12 = { class: "report-body-header_objective-header" }
const _hoisted_13 = { class: "report-body-header_objective-field" }
const _hoisted_14 = { class: "report-body" }
const _hoisted_15 = { class: "report-body_evaluation" }
const _hoisted_16 = { class: "report-body_evaluation-header" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"report-body_evaluation-progress\" data-v-0c52852d><div class=\"range-div\" data-v-0c52852d><span class=\"plus-sign\" data-v-0c52852d>+</span><div class=\"range\" data-v-0c52852d></div><span class=\"minus-sign\" data-v-0c52852d>-</span></div></div>", 1)
const _hoisted_18 = { class: "report-body_evaluation-content" }
const _hoisted_19 = { class: "report-body_evaluation-content-label" }
const _hoisted_20 = { class: "report-body_evaluation-content-values" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "evaluation-content-button_text" }
const _hoisted_23 = { class: "report-body_evaluation-content" }
const _hoisted_24 = { class: "report-body_evaluation-content-label" }
const _hoisted_25 = { class: "report-body_evaluation-content-values" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "evaluation-content-button_text" }
const _hoisted_28 = { class: "report-body_evaluation-content" }
const _hoisted_29 = { class: "report-body_evaluation-content-label" }
const _hoisted_30 = { class: "report-body_evaluation-content-values" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "evaluation-content-button_text" }
const _hoisted_33 = { class: "bien-etre-cont" }
const _hoisted_34 = { class: "bien-etre_text" }
const _hoisted_35 = { class: "bien-etre" }
const _hoisted_36 = { class: "bien-etre-rows" }
const _hoisted_37 = { class: "report-body_evaluation-content-label" }
const _hoisted_38 = { class: "report-body_evaluation-content-values" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "evaluation-content-button_text" }
const _hoisted_41 = { class: "bien-etre-rows" }
const _hoisted_42 = { class: "report-body_evaluation-content-label" }
const _hoisted_43 = { class: "report-body_evaluation-content-values" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "evaluation-content-button_text" }
const _hoisted_46 = { class: "report-body_objective-responsive" }
const _hoisted_47 = { class: "report-body-header_objective-header" }
const _hoisted_48 = { class: "report-body-header_objective-field" }
const _hoisted_49 = { class: "report-body_objective" }
const _hoisted_50 = { class: "report-body_objective_container" }
const _hoisted_51 = { class: "report-body_objective_header" }
const _hoisted_52 = { class: "report-body_objective_header_text" }
const _hoisted_53 = { class: "report-body_objective_header_buttons" }
const _hoisted_54 = { class: "report-body_objective_header_btnlike" }
const _hoisted_55 = { class: "report-body_objective_header_liftlike" }
const _hoisted_56 = { class: "report-body_objective_header_dislike" }
const _hoisted_57 = { class: "report-body_obj" }
const _hoisted_58 = { class: "report-body_objective_content" }
const _hoisted_59 = { class: "new-body" }
const _hoisted_60 = { class: "report-body_objective_content_row" }
const _hoisted_61 = { class: "objective_content_row_text" }
const _hoisted_62 = { class: "report-body_objective_container_btns" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = { class: "report-body_objective_next-container" }
const _hoisted_65 = { class: "report-body_objective_next-btn" }
const _hoisted_66 = { class: "report-body-footer" }
const _hoisted_67 = { class: "report-body-footer_default-btn-active" }
const _hoisted_68 = { class: "report-body-footer_default-btn-active_text" }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = { class: "report-body-footer_btn-text" }
const _hoisted_71 = { class: "alert-text-container" }
const _hoisted_72 = { class: "confirm-span" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Confirm = _resolveComponent("Confirm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('views.participantDashboard.report.meetingReport')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "active",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClose()))
        }, _toDisplayString(_ctx.$t('views.participantDashboard.report.close')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t('views.participantDashboard.report.reportTitle', {
                        name: _ctx.generateReportTitle().name,
                        date: _ctx.generateReportTitle().date,
                        time: _ctx.generateReportTitle().time,
                    })), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('views.participantDashboard.report.observation')), 1),
            _withDirectives(_createElementVNode("div", {
              class: _normalizeClass(["microphonespan cursor-pointer", { active: _ctx.isMicOn }]),
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleMic && _ctx.toggleMic(...args)))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-microphone" })
            ], 2), [
              [_vShow, _ctx.hasSpeechRecognition]
            ])
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.reportData.global_comment) = $event)),
            class: "report-body-header_observation-field"
          }, null, 512), [
            [_vModelText, _ctx.reportData.global_comment]
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('views.participantDashboard.report.objective')), 1),
            _createElementVNode("div", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openInfo(1))),
              class: "microphonespan cursor-pointer"
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-info" })
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              class: _normalizeClass(["report-body-header_objective-field-button", { active: _ctx.reportData.is_therapeutic }]),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.reportData.is_therapeutic = _ctx.reportData.is_therapeutic ? false : true))
            }, _toDisplayString(_ctx.$t('views.participantDashboard.report.therapeuticWorkshop')), 3)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('views.participantDashboard.report.evaluationOfTheSession')), 1)
          ]),
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('views.participantDashboard.report.attentionOfConcentration')), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (temp, index) => {
                return _createElementVNode("div", {
                  key: temp,
                  class: _normalizeClass(
                                    index === 0
                                        ? _ctx.reportData.results[0] === 5
                                            ? 'evaluation-content-first-button-active'
                                            : 'evaluation-content-first-button'
                                        : index === 1
                                        ? _ctx.reportData.results[0] === 4
                                            ? 'evaluation-content-second-button-active'
                                            : 'evaluation-content-second-button'
                                        : index === 2
                                        ? _ctx.reportData.results[0] === 3
                                            ? 'evaluation-content-third-button-active'
                                            : 'evaluation-content-third-button'
                                        : index === 3
                                        ? _ctx.reportData.results[0] === 2
                                            ? 'evaluation-content-fourth-button-active'
                                            : 'evaluation-content-fourth-button'
                                        : index === 4
                                        ? _ctx.reportData.results[0] === 1
                                            ? 'evaluation-content-fifth-button-active'
                                            : 'evaluation-content-fifth-button'
                                        : ''
                                ),
                  onClick: ($event: any) => (_ctx.onAppreciation(0, 5 - index))
                }, [
                  _createElementVNode("p", _hoisted_22, _toDisplayString(5 - index), 1)
                ], 10, _hoisted_21)
              }), 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('views.participantDashboard.report.understanding')), 1)
            ]),
            _createElementVNode("div", _hoisted_25, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (temp, index) => {
                return _createElementVNode("div", {
                  key: temp,
                  class: _normalizeClass(
                                    index === 0
                                        ? _ctx.reportData.results[1] === 5
                                            ? 'evaluation-content-first-button-active'
                                            : 'evaluation-content-first-button'
                                        : index === 1
                                        ? _ctx.reportData.results[1] === 4
                                            ? 'evaluation-content-second-button-active'
                                            : 'evaluation-content-second-button'
                                        : index === 2
                                        ? _ctx.reportData.results[1] === 3
                                            ? 'evaluation-content-third-button-active'
                                            : 'evaluation-content-third-button'
                                        : index === 3
                                        ? _ctx.reportData.results[1] === 2
                                            ? 'evaluation-content-fourth-button-active'
                                            : 'evaluation-content-fourth-button'
                                        : index === 4
                                        ? _ctx.reportData.results[1] === 1
                                            ? 'evaluation-content-fifth-button-active'
                                            : 'evaluation-content-fifth-button'
                                        : ''
                                ),
                  onClick: ($event: any) => (_ctx.onAppreciation(1, 5 - index))
                }, [
                  _createElementVNode("p", _hoisted_27, _toDisplayString(5 - index), 1)
                ], 10, _hoisted_26)
              }), 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('views.participantDashboard.report.mobilization')), 1)
            ]),
            _createElementVNode("div", _hoisted_30, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (temp, index) => {
                return _createElementVNode("div", {
                  key: temp,
                  class: _normalizeClass(
                                    index === 0
                                        ? _ctx.reportData.results[2] === 5
                                            ? 'evaluation-content-first-button-active'
                                            : 'evaluation-content-first-button'
                                        : index === 1
                                        ? _ctx.reportData.results[2] === 4
                                            ? 'evaluation-content-second-button-active'
                                            : 'evaluation-content-second-button'
                                        : index === 2
                                        ? _ctx.reportData.results[2] === 3
                                            ? 'evaluation-content-third-button-active'
                                            : 'evaluation-content-third-button'
                                        : index === 3
                                        ? _ctx.reportData.results[2] === 2
                                            ? 'evaluation-content-fourth-button-active'
                                            : 'evaluation-content-fourth-button'
                                        : index === 4
                                        ? _ctx.reportData.results[2] === 1
                                            ? 'evaluation-content-fifth-button-active'
                                            : 'evaluation-content-fifth-button'
                                        : ''
                                ),
                  onClick: ($event: any) => (_ctx.onAppreciation(2, 5 - index))
                }, [
                  _createElementVNode("p", _hoisted_32, _toDisplayString(5 - index), 1)
                ], 10, _hoisted_31)
              }), 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('views.participantDashboard.report.wellness')), 1),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('views.participantDashboard.report.valuation')), 1)
                ]),
                _createElementVNode("div", _hoisted_38, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (temp, index) => {
                    return _createElementVNode("div", {
                      key: temp,
                      class: _normalizeClass(
                                            index === 0
                                                ? _ctx.reportData.results[3] === 5
                                                    ? 'evaluation-content-first-button-active'
                                                    : 'evaluation-content-first-button'
                                                : index === 1
                                                ? _ctx.reportData.results[3] === 4
                                                    ? 'evaluation-content-second-button-active'
                                                    : 'evaluation-content-second-button'
                                                : index === 2
                                                ? _ctx.reportData.results[3] === 3
                                                    ? 'evaluation-content-third-button-active'
                                                    : 'evaluation-content-third-button'
                                                : index === 3
                                                ? _ctx.reportData.results[3] === 2
                                                    ? 'evaluation-content-fourth-button-active'
                                                    : 'evaluation-content-fourth-button'
                                                : index === 4
                                                ? _ctx.reportData.results[3] === 1
                                                    ? 'evaluation-content-fifth-button-active'
                                                    : 'evaluation-content-fifth-button'
                                                : ''
                                        ),
                      onClick: ($event: any) => (_ctx.onAppreciation(3, 5 - index))
                    }, [
                      _createElementVNode("p", _hoisted_40, _toDisplayString(5 - index), 1)
                    ], 10, _hoisted_39)
                  }), 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('views.participantDashboard.report.pleasure')), 1)
                ]),
                _createElementVNode("div", _hoisted_43, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (temp, index) => {
                    return _createElementVNode("div", {
                      key: temp,
                      class: _normalizeClass(
                                            index === 0
                                                ? _ctx.reportData.results[4] === 5
                                                    ? 'evaluation-content-first-button-active'
                                                    : 'evaluation-content-first-button'
                                                : index === 1
                                                ? _ctx.reportData.results[4] === 4
                                                    ? 'evaluation-content-second-button-active'
                                                    : 'evaluation-content-second-button'
                                                : index === 2
                                                ? _ctx.reportData.results[4] === 3
                                                    ? 'evaluation-content-third-button-active'
                                                    : 'evaluation-content-third-button'
                                                : index === 3
                                                ? _ctx.reportData.results[4] === 2
                                                    ? 'evaluation-content-fourth-button-active'
                                                    : 'evaluation-content-fourth-button'
                                                : index === 4
                                                ? _ctx.reportData.results[4] === 1
                                                    ? 'evaluation-content-fifth-button-active'
                                                    : 'evaluation-content-fifth-button'
                                                : ''
                                        ),
                      onClick: ($event: any) => (_ctx.onAppreciation(4, 5 - index))
                    }, [
                      _createElementVNode("p", _hoisted_45, _toDisplayString(5 - index), 1)
                    ], 10, _hoisted_44)
                  }), 64))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('views.participantDashboard.report.objective')), 1),
            _createElementVNode("div", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openInfo(1))),
              class: "microphonespan cursor-pointer"
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-info" })
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("button", {
              class: _normalizeClass(["report-body-header_objective-field-button", { active: _ctx.reportData.is_therapeutic }]),
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.reportData.is_therapeutic = _ctx.reportData.is_therapeutic ? false : true))
            }, _toDisplayString(_ctx.$t('views.participantDashboard.report.therapeuticWorkshop')), 3)
          ])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('views.participantDashboard.report.activityEvaluation')), 1)
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("button", _hoisted_54, [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-thumbs-up" })
                ]),
                _createElementVNode("button", _hoisted_55, [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-thumbs-up" })
                ]),
                _createElementVNode("button", _hoisted_56, [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-thumbs-up" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('generic.melovie')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (temp, index) => {
                        return _createElementVNode("button", {
                          key: temp,
                          class: _normalizeClass(
                                                    index === 0
                                                        ? _ctx.reportActivityData.score && _ctx.reportActivityData.score === 3
                                                            ? 'report-body_objective_container_success'
                                                            : 'report-body_objective_container_default'
                                                        : index === 1
                                                        ? _ctx.reportActivityData.score && _ctx.reportActivityData.score === 1
                                                            ? 'report-body_objective_container_warning'
                                                            : 'report-body_objective_container_default'
                                                        : index === 2
                                                        ? _ctx.reportActivityData.score !== undefined &&
                                                          _ctx.reportActivityData.score === 0
                                                            ? 'report-body_objective_container_danger'
                                                            : 'report-body_objective_container_default'
                                                        : ''
                                                ),
                          onClick: ($event: any) => (_ctx.onEvaluation(index))
                        }, null, 10, _hoisted_63)
                      }), 64))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("button", _hoisted_65, [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-chevron-right" })
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_66, [
        _createElementVNode("div", _hoisted_67, [
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('views.participantDashboard.report.managementBehavioralDisorder')), 1)
          ]),
          _createElementVNode("div", {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openInfo(2))),
            class: "microphonespan-footer cursor-pointer"
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-info" })
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.troubles, (trouble) => {
          return (_openBlock(), _createElementBlock("div", {
            key: trouble.tro_id,
            class: "report-body-footer_default-btn"
          }, [
            _createElementVNode("button", {
              onClick: ($event: any) => (_ctx.onSelectTrouble(trouble)),
              class: _normalizeClass(["report-body-footer_btn", { active: trouble.tro_id === _ctx.reportData.tro_id }])
            }, [
              _createTextVNode(_toDisplayString(trouble.trouble_name) + " ", 1),
              _createElementVNode("div", _hoisted_70, _toDisplayString(trouble.effect_name), 1)
            ], 10, _hoisted_69)
          ]))
        }), 128))
      ])
    ]),
    (_ctx.reportFooterPopup)
      ? (_openBlock(), _createBlock(_component_Confirm, {
          key: 0,
          data: _ctx.reportPopupData,
          maxHeight: "50vh"
        }, {
          alertBody: _withCtx(() => [
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("p", null, "- " + _toDisplayString(_ctx.$t('views.participantDashboard.report.ResidentsWithDisruptive')), 1),
              _createElementVNode("p", null, "- " + _toDisplayString(_ctx.$t('views.participantDashboard.report.AnxiousStates')), 1),
              _createElementVNode("p", _hoisted_72, "- " + _toDisplayString(_ctx.$t('views.participantDashboard.report.ResidentsWith')), 1)
            ])
          ]),
          _: 1
        }, 8, ["data"]))
      : _createCommentVNode("", true)
  ]))
}